<input #upload type="file" name="file" [attr.multiple]="multiple" (change)="selectFile($event)" class="d-none" />
<div *ngFor="let file of files" class="row pb-3 file align-middle">
  <div class="col text-break">
    {{file.file.name}}
  </div>
  <div class="col-auto">
    <!--<dropdown [showEmptyValue]="'true'"
              [view]="uploadTypeView"
              [itemsView]="uploadTypeItemViews"></dropdown>-->

    <div class="dropdown">
      <button class="btn dropdown-toggle control-border-b p-0 text-left d-flex align-items-center justify-content-between"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false">
        <span class="upload-type-text">{{ file.uploadType?.title || strings.getString('SelectUploadType') }}</span>        
      </button>

      <div class="dropdown-menu">
        <button class="dropdown-item"
                type="button"
                *ngFor="let type of uploadTypes"
                (click)="setFileType(file, type)">
          {{ type.title }}
        </button>
      </div>
    </div>
  </div>
  <div class="col-5">
    <div class="progress">
      <div [ngClass]="{'progress-bar progress-bar-striped progress-bar-animated': file.running}" class="text-center" role="progressbar" [style.width]="file.running ? file.percentDone + '%' : 'auto'" [class.bg-success]="file.done" [class.bg-danger]="file.error">{{file.text}}</div>
    </div>
  </div>
  <div *ngIf="!file.done" class="col-auto clickable align-middle mobile-flex delete-button" role="button" title="{{strings.Remove}}" (click)="onDeleteClick(file)">
    <co-image width="24" height="24" type="svg" key="delete" imageSet="red"></co-image>
  </div>
</div>

<button *ngIf="!files || files.length == 0" (click)="add()">{{strings.SelectFiles}}</button>